export enum DeliveryChoice {
  AtClinic = 'VET',
  AtPetOwnerPlace = 'PO',
}
